module.exports = __webpack_public_path__ + "img/CIX.cbc638da.svg";